/**
 * connected-handlers.js
 */

import React from 'react';
import { useMediaQuery } from '@mui/material';
import { makeLocation } from 'utils/routing';
import ConnectedHandlersMobile from './connected-handlers-mobile';
import ConnectedHandlersDesktop from './connected-handlers-desktop';
import ConnectedHandlersDrawer from './connected-handlers-drawer';


export const connectionsPath = 'connections';


export const connectionsRoute = (history) => {
  return makeLocation('', 'groups', 'connections', {}, history?.location);
}


export default function ConnectedHandlers(props) {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down('sm'), { noSsr: true });

  return (
    <>
      {isMobile && <ConnectedHandlersMobile />}
      {!isMobile && <ConnectedHandlersDesktop />}
      <ConnectedHandlersDrawer />
    </>
  )
}